<div [class.electron]="platformService.isElectronApp" [class.collapsed]="!state.extended" id="container">
  <div *ngIf="userService.currentUser" id="profile-icon">
    <div>
      <div class="username">{{userService.currentUser.username}}</div>
      <div class="user-company">{{tenantName}}</div>
    </div>

    <avatar-component></avatar-component>
  </div>

  <div id="top-buttons">
    <div (click)="changeExtended()" class="button-container" pRipple [pTooltip]="showToolTip('Menu')">
      <div class="title">Menu</div>
      <div class="icon">
<!--        <i class="fas fa-bars"></i>-->
<!--        <i class="fas fa-arrow-right"></i>-->
        <i class="fas" [class.fa-arrow-left]="state.extended" [class.fa-bars]="!state.extended"></i>
      </div>
    </div>

    <div
        (click)="changePage(i)"
        *ngFor="let page of pages; let i = index;"
        [class.button-container-selected]="highlighted(i)"
        [pTooltip]="showToolTip(page)"
        class="button-container"
        pRipple>

      <div class="title" [class.title-selected]="highlighted(i)">{{page}}</div>

      <div
        [class.icon-selected]="highlighted(i)"
        class="icon"><i [className]="icons[i]"></i>
      </div>

    </div>
  </div>

  <div id="bottom-buttons">
    <ng-container *ngIf="isDev">
      <div>FR#{{frontEndVersion}}#{{frontEndBuildNumber}}</div>
      <div *ngIf="desktopWrapperVersionAndBuildNumber">DW#{{desktopWrapperVersionAndBuildNumber}}</div>
    </ng-container>
    <div *ngIf="isAdmin()" (click)="openSettings()" class="button-container" pRipple [pTooltip]="showToolTip('Settings')">
      <div class="title">Settings</div>
      <div class="icon"><i class="fa-sharp fa-solid fa-gear"></i></div>
    </div>
    <div *ngIf="isAdmin()" (click)="openInvitationWebsite()" class="button-container" pRipple [pTooltip]="showToolTip('Invite')">
      <div class="title">Invite</div>
      <div class="icon"><i class="fas fa-user-plus"></i></div>
    </div>
    <div (click)="openExitContainer()" class="button-container" pRipple [pTooltip]="showToolTip('Log Out')">
      <div class="title">Exit</div>
      <div class="icon"><i class="fas fa-sign-out-alt"></i></div>
    </div>
  </div>


  <div class="exit-options-container" *ngIf="exitContainerOpen" (mouseenter)="keepExitContainerOpen()" (mouseleave)="closeExitContainer()">
    <div class="exit-option button-container" (click)="changeOrganization()">
      <div class="title">Change Organization</div>
      <div class="icon"><i class="fas fa-globe-americas"></i></div>
    </div>
    <div class="exit-option button-container" (click)="logout()">
      <div class="title">Log Out</div>
      <div class="icon"><i class="fas fa-person-to-door"></i></div>
    </div>
    <div class="exit-option button-container" *ngIf="platformService.isElectronApp" (click)="exit()">
      <div class="title">Exit Application</div>
      <div class="icon"><i class="fas fa-times"></i></div>
    </div>
  </div>
</div>

<app-account-settings-modal [settingsPopupOpen]="settingsOpen" (onClose)="settingsOpen=false"></app-account-settings-modal>

